import DirectionServicesView from '@/components/DirectionServicesView';

export default function SubDirectionPage(props) {
  const { direction, directions, banners, short_content } = props;

  return (
    <DirectionServicesView
      banners={banners}
      directions={directions}
      short_content={short_content}
      activeSlug={direction?.slug}
    />
  );
}
